import LogRocket from "logrocket";
import { AbstractTrackingService } from "./abstract-tracking-service";
import type { Me } from "@/generated/graphql";
import type { TrackEventEnum, TrackOptions } from "./tracking-types";
import { setLogRocketSessionURL } from "@/utils/headers";
import type { ChannelMetadata } from "@/models";

export class LogRocketService extends AbstractTrackingService {
  name = "LogRocketService";

  private logRocketId: string;

  constructor(logRocketId: string) {
    super();
    this.logRocketId = logRocketId;
  }

  public async init(channelMetadata: ChannelMetadata) {
    await super.init(channelMetadata);

    LogRocket.init(this.logRocketId);
    this.initialized = true;

    try {
      LogRocket.getSessionURL(function (sessionURL) {
        setLogRocketSessionURL(sessionURL);
      });
    } catch (error) {
      console.error("[LogRocketService] Unable to get session url,", error);
    }
  }

  public identifyChannel(): void {
    // Do nothing
  }

  public identifyUser(user: Me): void {
    if (!user) return;

    const traits: Record<string, string | number | boolean> = {
      name: user.username,
      id: user.id,
      email: user.email,
      phone_number: user.phone_number,
      locale: user.locale,
    };

    try {
      LogRocket.identify(user.id, traits);
      console.log("[LogRocketService] User successfully identified");
    } catch (error) {
      console.error("[LogRocketService] Error identifying user:", error);
    }
  }

  public resetIdentity() {
    console.log("[LogRocketService] Resetting identity");
    try {
      LogRocket.startNewSession();
      console.log("[LogRocketService] New session started");
    } catch (error) {
      console.error("[LogRocketService] Error starting new session:", error);
    }
  }

  public track<T extends TrackEventEnum>(_options: TrackOptions<T>) {}
}
